import { createContext } from 'react';
export var InstantSearchServerContext = /*#__PURE__*/createContext(null);

if (process.env.NODE_ENV !== 'production') {
  InstantSearchServerContext.displayName = 'InstantSearchServer';
}